const routes = [
    {
        path: "/agencies",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'agency_index'
        }
    }
];

export default routes;
